import * as React from "react";

function SvgSlicingDice(props, ref) {
  return (
    <svg
      id="SlicingDice_svg__Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-10 -5 162 164"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <defs>
        <style />
      </defs>
      <path fill="#939393" d="M68.08 157.18L0 118.25V38.94l68.08 38.94v79.3z" />
      <path
        fill="#a5a5a5"
        d="M136.15 118.25l-68.07 38.93v-79.3l68.07-38.94v79.31z"
      />
      <path
        fill="#cecece"
        d="M136.15 38.94L68.08 0 0 38.94l68.08 38.94 68.07-38.94z"
      />
      <path fill="#fffcfa" d="M94.41 62.82l-9.47 5.41v79.31l9.47-5.42v-79.3z" />
      <path fill="#fbffff" d="M110.81 53.44v79.3l7.93-4.53V48.9l-7.93 4.54z" />
      <path fill="#41a5a0" d="M110.81 53.44l-16.4 9.38v79.3l16.4-9.38v-79.3z" />
      <path
        fill="#fdfbfa"
        d="M94.41 62.82L50.96 37.87l16.53-9.45 43.32 25.02 7.93-4.54-50.66-29.94-34.04 19.98 50.9 29.29 15.53-8.88-6.06 3.47z"
      />
      <path
        fill="#46bcb9"
        d="M50.96 37.87l43.45 24.95 16.4-9.38-43.32-25.02-16.53 9.45z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgSlicingDice);
